module.exports = __webpack_public_path__ + "static/media/AvenirNextLTPro-Thin.1fb6948e.woff2";